import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Img — a pass-through <img> atom for cases where SanityImage is not appropriate.
 * Primary use case: poster frames, inline SVG data URIs, or images whose source
 * is external to the CMS (e.g. video poster frames computed at runtime).
 *
 * For all Sanity-hosted content images, use SanityImage instead.
 *
 * @atomic-tier Atom
 * @category Media
 */

export type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>

const Img = React.forwardRef<HTMLImageElement, ImgProps>(
  ({ className, alt = "Decorative image", ...props }, ref) => (
    <img ref={ref} className={cn(className)} alt={alt} {...props} />
  ),
)
Img.displayName = "Img"

export { Img }
